import { RequestApi, RequestVersionedApi } from '@helpers';

const employeeActionItems = (employeeID) => RequestApi.get(`/Certificate/employeeActionItems?employeeID=${employeeID}`);

const updateEmployeeLastLogin = (payload) => RequestVersionedApi.put(`/Employees/updateEmployeeLogin`, payload);

export default {
    employeeActionItems,
    updateEmployeeLastLogin
};